import { render } from "./Tab.vue?vue&type=template&id=c45271a8&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=c45271a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tmeadows\\WebstormProjects\\tuitioncalculator\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45271a8"]])

export default __exports__